import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CustomChatService } from './custom-chat.service';
import { ChatMessage } from './model/chatMessage';
import { marked } from 'marked'

@Component({
  standalone: false,
  selector: 'app-custom-chat',
  templateUrl: './custom-chat.component.html',
  styleUrls: ['./custom-chat.component.scss']
})
export class CustomChatComponent implements OnInit {
  public pageTitle: string = "IVI Assistant";
  public inputMessage: string = "";
  public chatDisplay: ChatMessage[] = [];
  public isProcessing: boolean = false;
  public hideFeedbackBox: boolean = true;
  public feedbackComment: string = "";
  public feedbackRating: number = 0;
  public feedbackCurrentMessage: ChatMessage = new ChatMessage();
  private session_id: string = "";
  private initialMessage: string = "Hello! I'm your AI - powered assistant. I'm here to help you understand how IVI works and answer any questions you may have. I can also suggest delicious recipes and assist with planning your perfect menu. Just ask!";

  @Output() onNavToggleChat = new EventEmitter();

  constructor(
    private customChatService: CustomChatService,
  ) { }

  ngOnInit() {
    this.chatDisplay.push(new ChatMessage(this.initialMessage, false));
  }

  public clickClearChat() {
    this.chatDisplay = [];
    this.chatDisplay.push(new ChatMessage(this.initialMessage, false));
    this.inputMessage = '';
    this.session_id = "";
    if (!this.hideFeedbackBox)
      this.closeFeedback();
    this.setFocusInput();
  }

  private setFocusInput() {
    setTimeout(() => {
      document.getElementById("chatInputField")!.focus();
    });
  }

  private setChatReady() {
    this.inputMessage = '';
    this.isProcessing = false;
    this.setFocusInput();
    this.scrollToChatEnd();
  }

  private scrollToChatEnd() {
    setTimeout(() => {
      document.getElementsByClassName("chatbox")[0].lastElementChild!.scrollIntoView();
    });
  }

  public sendMessage() {
    if (this.inputMessage.trim()) {
      this.isProcessing = true;
      this.chatDisplay.push(new ChatMessage(this.inputMessage, true));
      this.scrollToChatEnd();
      this.getChatbotResponse(this.inputMessage);
    }
  }

  private getChatbotResponse(userQuery: string) {
    this.customChatService.IVIChatbot(userQuery, this.session_id).subscribe({
      next: (res: any) => {
        if (res.errorMessage.length > 0) {
          this.chatDisplay.push(new ChatMessage('Sorry, there was an error processing your request.', false));
        }
        else if (!res.entity.answer) {
          this.chatDisplay.push(new ChatMessage('Sorry, no data available for this query.', false));
        }
        else {
          this.session_id = res.entity.session_id;
          this.chatDisplay.push(new ChatMessage(marked.parse(res.entity.answer) as string, false, res.entity.message_id));
        }
        this.setChatReady();
      }
    });
  }

  public clickFeedback(data: ChatMessage, rating: number) {
    if (!this.isProcessing) {
      this.isProcessing = true;
      this.feedbackCurrentMessage = data;
      this.feedbackRating = rating;
      this.feedbackComment = data.comment;
      this.hideFeedbackBox = false;
    }
  }

  public changeFeedback(rating: number) {
    this.feedbackRating = rating;
  }

  public closeFeedback() {
    this.isProcessing = false;
    this.hideFeedbackBox = true;
  }

  public sendFeedback() {
    this.feedbackCurrentMessage.rating = this.feedbackRating;
    this.feedbackCurrentMessage.comment = this.feedbackComment;
    this.customChatService.IVIChatbotFeedback(this.session_id, this.feedbackCurrentMessage.message_id, this.feedbackRating, this.feedbackComment).subscribe({
      next: (res: any) => {
        this.hideFeedbackBox = true;
        if (res.errorMessage.length > 0 || res.entity.status != 'success') {
          this.feedbackCurrentMessage.rating = 0;
          this.feedbackCurrentMessage.comment = '';
          this.chatDisplay.push(new ChatMessage('Sorry, there was an error processing your feedback.', false));
          this.setChatReady();
        }
        else {
          this.chatDisplay.push(new ChatMessage('Thank you for the feedback.', false));
          this.setChatReady();
        }
      }
    });
  }

  public navToggleChat() {
    this.onNavToggleChat.emit();
  }
}
